export function createClientRequestId() {
  const webCrypto = globalThis.crypto;
  if (typeof webCrypto?.randomUUID === "function") return webCrypto.randomUUID();
  if (typeof webCrypto?.getRandomValues === "function") {
    const bytes = webCrypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((value) => value.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export function getIdempotencyKey(scope: string) {
  if (typeof window === "undefined") return createClientRequestId();
  const storageKey = `prvbuy:idempotency:${scope}`;
  const existing = window.sessionStorage.getItem(storageKey);
  if (existing) return existing;
  const key = createClientRequestId();
  window.sessionStorage.setItem(storageKey, key);
  return key;
}

export function rotateIdempotencyKey(scope: string) {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(`prvbuy:idempotency:${scope}`);
}
